// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"print-multiple-compare-successor_wrapper__uGmnP","title":"print-multiple-compare-successor_title__bEldT"};